import ReactMarkdown from "react-markdown";

export const Markdown = ({ children }) => (
  <ReactMarkdown
    components={{
      h1: (p) => <h1 className="mb-4 mt-8 font-editorial text-3xl font-semibold first:mt-0" {...p} />,
      h2: (p) => <h2 className="mb-3 mt-7 font-editorial text-xl font-semibold" {...p} />,
      h3: (p) => <h3 className="mb-2 mt-5 text-base font-semibold" {...p} />,
      p: (p) => <p className="mb-4 leading-relaxed" {...p} />,
      ul: (p) => <ul className="mb-4 list-disc space-y-1.5 pl-6" {...p} />,
      ol: (p) => <ol className="mb-4 list-decimal space-y-1.5 pl-6" {...p} />,
      li: (p) => <li className="leading-relaxed" {...p} />,
      a: (p) => <a className="text-[color:var(--evergreen)] underline underline-offset-2" target="_blank" rel="noreferrer" {...p} />,
      strong: (p) => <strong className="font-semibold" {...p} />,
      em: (p) => <em className="italic opacity-80" {...p} />,
      hr: () => <hr className="my-6 border-[color:var(--ink-hairline)]" />,
      blockquote: (p) => <blockquote className="mb-4 border-l-2 border-[color:var(--evergreen)] pl-4 italic" {...p} />,
    }}
  >
    {children || ""}
  </ReactMarkdown>
);

export default Markdown;
